// removed by extract-text-webpack-plugin
module.exports = {"colorSwatch--light":"_1PoktEnuxu4_b47iKBqmC2","colorSwatch--unavailable":"_10FMIxdUmE_6N0LDSpsVux","colorSwatch--dark":"_1jImuh97a2Tba5bak3pAUR","colorSwatch__sample":"z_SKnCNd_T_uG15fWc5lM","colorSwatch__label":"_318X0hXaC5fMNRx4pyrLzE"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/style.scss
// module id = 875
// module chunks = 0